import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

const STATUS_PILL = { publicado: "pub", revision: "rev", borrador: "draft" };
const STATUS_LBL = { publicado: "Publicado", revision: "En revisión", borrador: "Borrador" };

export default function Dashboard() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/dashboard").then((r) => setData(r.data)).catch(() => {}); }, []);

  const k = data?.kpis || {};
  return (
    <div data-testid="admin-dashboard">
      <h1 className="page">Dashboard</h1>
      <p className="pagesub">Síntesis publicadas y artículos pendientes de revisión en Legis BC.</p>
      <div className="cards">
        <div className="kpi" data-testid="kpi-articulos"><b>{k.articulos ?? "—"}</b><span>Artículos publicados</span></div>
        <div className="kpi" data-testid="kpi-sintesis"><b>{k.sintesis ?? "—"}</b><span>Síntesis publicadas</span></div>
        <div className="kpi" data-testid="kpi-suscriptores"><b>{k.suscriptores ?? "—"}</b><span>Suscriptores</span></div>
        <div className="kpi" data-testid="kpi-campanas"><b>{k.campanas ?? "—"}</b><span>Campañas de correo</span></div>
      </div>
      <div className="panel">
        <h2>Actividad reciente</h2>
        <table>
          <thead><tr><th>Contenido</th><th>Tipo</th><th>Autor</th><th>Estado</th></tr></thead>
          <tbody>
            {(data?.sintesis_recientes || []).map((s) => (
              <tr key={s.id}>
                <td><b>Síntesis Legislativa — {s.fecha_label}</b></td>
                <td><span className="pill tag">Síntesis</span></td>
                <td>Documento de origen</td>
                <td><span className="pill pub">{s.status === "publicado" ? "Publicada" : "Borrador"}</span></td>
              </tr>
            ))}
            {(data?.articulos_recientes || []).map((a) => (
              <tr key={a.id}>
                <td><b>{a.title}</b></td>
                <td><span className="pill tag">{a.kind === "analisis" ? "Análisis" : "Nota"}</span></td>
                <td>{a.author}</td>
                <td><span className={`pill ${STATUS_PILL[a.status] || "draft"}`}>{STATUS_LBL[a.status] || a.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="panel" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "linear-gradient(100deg,var(--navy),#1d5a85)", border: "none", gap: 16, flexWrap: "wrap" }}>
        <div style={{ color: "#fff" }}>
          <h2 style={{ color: "#fff" }}>Próxima sesión del Congreso del Estado</h2>
          <p style={{ fontSize: 13.5, color: "#c9d6e2" }}>Genera la síntesis legislativa automáticamente a partir del Orden del Día.</p>
        </div>
        <button className="btn btn-green" onClick={() => navigate("/admin/sintesis")} data-testid="start-sintesis-button">⚖ Iniciar síntesis automática</button>
      </div>
    </div>
  );
}
